import { render } from "./CreatePasswordPage.vue?vue&type=template&id=3977940a&ts=true"
import script from "./CreatePasswordPage.vue?vue&type=script&lang=ts"
export * from "./CreatePasswordPage.vue?vue&type=script&lang=ts"

import "./CreatePasswordPage.vue?vue&type=style&index=0&id=3977940a&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__